import { POST_STAFF_CARDS_START } from '../../types';

export const post_staff_cards = (payload) => ({
  type: POST_STAFF_CARDS_START,
  payload,
});
